<template>
  <div id="contenedor-tool-bar-pagos">
    <v-toolbar
      flat
      dense>
      <div
        style="width: 150px" class="mr-2">
        <ejercicio-picker
          v-model="filtros.ejercicio"
          class="mr-2">
        </ejercicio-picker>
      </div>
      <div
        style="width: 350px"
        class="mr-2">
        <custom-text-field
          label="Buscar..."
          append-icon="mdi-magnify"
          clearable
          @keyup="buscar"
          @click:clear="limpiarBuscadorTexto">
        </custom-text-field>
      </div>
      <v-spacer></v-spacer>
      <custom-button
        @click="nuevo"
        label="Solicitar"
        tipo="agregar">
      </custom-button>
    </v-toolbar>
  </div>
</template>

<script>
import EjercicioPicker from '@/components/inputs/EjercicioPicker.vue';
import CustomButton from '@/components/buttons/Button.vue';
import CustomTextField from '@/components/inputs/sinColumnas/TextField.vue';

export default {
  name: 'ToolBarPagos',
  components: {
    EjercicioPicker,
    CustomButton,
    CustomTextField,
  },
  props: {
    filtros: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      debounce: null,
    };
  },
  methods: {
    buscar(e) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.filtros.buscarTexto = e.target.value;
      }, 600);
    },
    limpiarBuscadorTexto() {
      this.filtros.buscarTexto = '';
    },
    nuevo() {
      this.$emit('nuevaSolicitud');
    },
  },
};
</script>

<style lang="scss">

</style>
